<template lang='pug'>
HelloWorld(
  :date='date'
)
</template>

<script>
import HelloWorld from '../components/HelloWorld.vue';

export default
{
  name: 'HomeView',
  components:
  {
    HelloWorld,
  },
  props:
  {
    date: { required: true },
  },
};
</script>
